import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { siteInfo } from '@/mocks/movies';

export default function AboutPage() {
  const advantages = [
    {
      icon: 'ri-shield-check-line',
      title: '安全可靠',
      desc: '8年稳定运营，200万+日活用户信赖之选。无需注册即可免费观看，保护您的隐私安全。',
    },
    {
      icon: 'ri-speed-up-line',
      title: '极速播放',
      desc: '采用先进的CDN加速技术，全球多节点部署，确保高清流畅播放，告别卡顿缓冲。',
    },
    {
      icon: 'ri-film-line',
      title: '海量资源',
      desc: '拥有超过50,000部电影、电视剧、动漫、综艺等资源，涵盖国内外热门内容。',
    },
    {
      icon: 'ri-refresh-line',
      title: '每日更新',
      desc: '专业影视团队全天候更新，热门影片上映后24小时内即可在平台观看。',
    },
    {
      icon: 'ri-device-line',
      title: '全平台支持',
      desc: '完美适配电脑、平板、手机等所有设备，随时随地享受观影乐趣。',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '贴心服务',
      desc: '7×24小时在线客服，及时解决播放问题和观影需求，用户满意度高达98%。',
    },
  ];

  const userReviews = [
    {
      name: '影迷小张',
      rating: 5,
      date: '2026-07-28',
      content: '用了7777影院快三年了，资源更新速度是真的快！新片基本上当天就能看到，画质也特别清晰。最赞的是不用注册就能看，太方便了！',
    },
    {
      name: '剧荒拯救者',
      rating: 5,
      date: '2026-07-25',
      content: '作为一个重度追剧爱好者，7777影院简直就是我的精神食粮！电视剧大全分类特别清晰，找剧超方便。推荐给了好多朋友，都说好用。',
    },
    {
      name: '电影发烧友',
      rating: 5,
      date: '2026-07-20',
      content: '收藏夹里的宝藏网站！热门推荐和同类推荐功能很智能，帮我发现了好多冷门好片。播放体验也很流畅，基本不会卡。',
    },
    {
      name: '深夜追剧人',
      rating: 4,
      date: '2026-07-15',
      content: '每天晚上必刷的平台，资源全、更新快、画质好。希望以后能加个下载功能就更完美了！不过在线看已经够用了。',
    },
    {
      name: '影视收藏家',
      rating: 5,
      date: '2026-07-10',
      content: '从2019年就开始用了，算是老用户了吧。见证了7777影院从几百部片源发展到现在的五万多部，真的是越做越好！分类筛选功能特别赞。',
    },
    {
      name: '周末影咖',
      rating: 5,
      date: '2026-07-05',
      content: '每个周末都会在这里找电影看，热门推荐的质量很高，基本不会踩雷。画面高清，音质也好，在家就能享受影院般的观影体验。',
    },
  ];

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main className="pt-16">
        {/* Breadcrumb */}
        <div className="px-4 md:px-6 py-4">
          <div className="max-w-[1400px] mx-auto">
            <nav className="flex items-center gap-2 text-xs text-foreground-400" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-600">关于我们</span>
            </nav>
          </div>
        </div>

        {/* Brand Introduction */}
        <section className="px-4 md:px-6 py-8 md:py-14">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-10">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-primary-500 rounded-xl">
                <i className="ri-movie-2-line text-3xl text-white"></i>
              </div>
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                关于7777影院
              </h1>
              <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
                7777影院（77777777影院）成立于2018年，是国内领先的免费在线影院平台。我们致力于为全球华人用户提供海量高品质的影视资源，打造极致的在线观影体验。
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div>
                <h2 className="text-xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                  我们的故事
                </h2>
                <div className="space-y-3 text-sm text-foreground-500 leading-relaxed">
                  <p>
                    2018年，一群热爱电影的技术人聚在一起，怀揣着一个简单的梦想——让每个人都能轻松看到想看的电影。于是，7777影院诞生了。
                  </p>
                  <p>
                    从最初的几百部影片起步，到如今拥有超过50,000部海量资源，我们始终坚持"免费、高清、便捷"的核心理念。八年来，我们陪伴了两亿多用户的观影时光，成为了国内最受欢迎的免费在线影院之一。
                  </p>
                  <p>
                    我们深知，在信息爆炸的时代，用户最需要的不是眼花缭乱的功能，而是简单、快速、高质量地观看到心仪的影片。因此，我们不断优化播放技术，完善内容分类，提升用户体验，让每一次观影都成为一种享受。
                  </p>
                  <p>
                    未来，7777影院将继续加大在技术和内容方面的投入，为全球华人用户提供更加丰富、优质的影视内容。我们相信，好的电影值得被更多人看到。
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                {[
                  { value: '2018年', label: '创立时间' },
                  { value: '50,000+', label: '影视资源' },
                  { value: '200万+', label: '日活用户' },
                  { value: '98%', label: '用户满意度' },
                ].map((stat, idx) => (
                  <div key={idx} className="p-5 rounded-lg bg-background-100 text-center">
                    <div className="text-xl md:text-2xl font-bold text-primary-500 mb-1" style={{ fontFamily: 'var(--font-heading)' }}>
                      {stat.value}
                    </div>
                    <p className="text-foreground-400 text-xs">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Advantages */}
        <section className="px-4 md:px-6 py-8 md:py-14 bg-background-100">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                为什么选择7777影院
              </h2>
              <p className="text-foreground-400 text-sm">六大核心优势，打造极致观影体验</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {advantages.map((item, idx) => (
                <div key={idx} className="p-5 rounded-lg bg-background-50 border border-background-200/60">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 mb-3">
                    <i className={`${item.icon} text-xl text-primary-500`}></i>
                  </div>
                  <h3 className="text-foreground-950 font-semibold text-sm mb-2">{item.title}</h3>
                  <p className="text-foreground-400 text-xs leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* User Reviews */}
        <section className="px-4 md:px-6 py-8 md:py-14">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                用户口碑
              </h2>
              <p className="text-foreground-400 text-sm">听听用户怎么说</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {userReviews.map((review, idx) => (
                <div key={idx} className="p-5 rounded-lg bg-background-100 border border-background-200/60">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-full bg-primary-500/20 flex items-center justify-center">
                        <span className="text-primary-500 text-xs font-bold">
                          {review.name.charAt(0)}
                        </span>
                      </div>
                      <span className="text-foreground-600 text-sm font-medium">{review.name}</span>
                    </div>
                    <span className="text-foreground-400 text-xs">{review.date}</span>
                  </div>
                  <div className="flex items-center gap-1 mb-2">
                    {Array.from({ length: review.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                    ))}
                    {Array.from({ length: 5 - review.rating }).map((_, i) => (
                      <i key={i} className="ri-star-line text-foreground-300 text-xs"></i>
                    ))}
                  </div>
                  <p className="text-foreground-500 text-xs leading-relaxed">{review.content}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="px-4 md:px-6 py-8 md:py-14 bg-background-100">
          <div className="max-w-[800px] mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                联系我们
              </h2>
              <p className="text-foreground-400 text-sm">如有任何问题或建议，欢迎通过以下方式联系我们</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
              <div className="p-6 rounded-lg bg-background-50 border border-background-200/60 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-500/10">
                  <i className="ri-mail-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-foreground-950 font-medium text-sm mb-1">电子邮箱</h3>
                <p className="text-foreground-500 text-xs">{siteInfo.email}</p>
              </div>
              <div className="p-6 rounded-lg bg-background-50 border border-background-200/60 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-500/10">
                  <i className="ri-phone-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-foreground-950 font-medium text-sm mb-1">客服电话</h3>
                <p className="text-foreground-500 text-xs">{siteInfo.phone}</p>
              </div>
              <div className="p-6 rounded-lg bg-background-50 border border-background-200/60 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-500/10">
                  <i className="ri-map-pin-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-foreground-950 font-medium text-sm mb-1">公司地址</h3>
                <p className="text-foreground-500 text-xs">{siteInfo.address}</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-[800px] mx-auto text-center">
            <h2 className="text-xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
              立即开启你的观影之旅
            </h2>
            <p className="text-foreground-400 text-sm mb-6">
              50,000+影视资源等你来发现，每日更新，免费观看
            </p>
            <Link
              to="/category/all"
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 rounded-md text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line text-lg"></i>
              开始免费观影
            </Link>
          </div>
        </section>
      </main>

      {/* Schema.org */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://7777cinema.com/' },
              { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://7777cinema.com/about' },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于7777影院',
            description: siteInfo.description,
            url: 'https://7777cinema.com/about',
          }),
        }}
      />

      <Footer />
    </>
  );
}